export default __webpack_public_path__ + "static/media/mini-success.efd8b88f.png";